import { all } from 'redux-saga/effects';

import { globalSaga } from './global';
import { audioSaga } from './audio';
import { mapSaga } from './map';

export default function* rootSaga() {
  yield all([...globalSaga, ...audioSaga, ...mapSaga]);
}
